// app/javascript/projects/components/TeamModalRemove.jsx

import React from 'react';
import AccountSingleButton from './AccountSingleButton'
import { useSubscription } from '../../hooks/subscriptions/queries';
import { useRemoveSeat } from '../../hooks/subscriptions/mutations';
import { getSubscriptionInterval } from '../../utils/subscriptionUtils';

function TeamModalRemove({ pageData, navigateToPage, PAGES }) {
  const { data: subscription } = useSubscription();
  const removeSeatMutation = useRemoveSeat();
  
  const seatId = pageData?.seatId;

  const handleConfirm = () => {
    if (seatId && subscription?.id) {
      removeSeatMutation.mutate(
        { subscriptionId: subscription.id, seatId },
        {
          onSuccess: () => {
            // Navigate back to main page on success
            navigateToPage(PAGES.MAIN_PAGE);
          }
        }
      );
    }
  };

  return (
    <AccountSingleButton
      error={removeSeatMutation.error ? {
        error: true,
        message: "Something went wrong, please refresh and try again."
      } : null}
      onClick={handleConfirm}
      loading={removeSeatMutation.isPending}
      header="Review the details"
      button="Confirm Subscription Change"
      disclaimer={`By removing a team member, you agree to receive a
        prorated credit to go toward your next ${getSubscriptionInterval(subscription)}'s subscription
        and you agree to automatically be charged each ${getSubscriptionInterval(subscription)}
        with your updated number of team members until you cancel.`}
      body={<p>You are reducing your subscription by 1 team member.</p>}
    />
  );
}

export default TeamModalRemove;